import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
import { ClipboardCheck, Sparkles, Heart, MessageCircle } from 'lucide-react';
const benefits = [{
  icon: ClipboardCheck,
  title: 'Diagnóstico personalizado',
  description: 'Evaluamos tu piel en profundidad para entender sus necesidades únicas antes de cualquier procedimiento.'
}, {
  icon: Sparkles,
  title: 'Protocolos pensados para tu piel',
  description: 'Tratamientos diseñados específicamente para ti, combinando las mejores técnicas y productos.'
}, {
  icon: Heart,
  title: 'Ambiente de paz y confianza',
  description: 'Un espacio seguro y relajante donde puedes desconectar del mundo y enfocarte en ti.'
}, {
  icon: MessageCircle,
  title: 'Seguimiento y recomendaciones',
  description: 'No te dejamos sola; te guiamos con rutinas y consejos para mantener los resultados en casa.'
}];
export function Experiences() {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });
  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  // Header animation
  const headerY = useTransform(smoothProgress, [0, 0.3], [50, 0]);
  const headerOpacity = useTransform(smoothProgress, [0, 0.2], [0, 1]);
  return <section ref={containerRef} className="py-24 md:py-40 bg-ivory-dark overflow-hidden" data-id="element-56">
      <div className="max-w-6xl mx-auto px-6" data-id="element-57">
        <motion.div style={{
        y: headerY,
        opacity: headerOpacity
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-58">
          <h2 className="text-3xl md:text-5xl font-serif text-softBlack mb-6" data-id="element-59">
            Creamos las experiencias para nuestros clientes
          </h2>
          <p className="text-lg text-warmGray font-light" data-id="element-60">
            Más que un tratamiento, un ritual diseñado para que te sientas
            cuidada desde que llegas hasta que te miras al espejo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-61">
          {benefits.map((benefit, index) => {
          // Calculate stagger based on index
          // Start range shifts later for each item
          const start = 0.1 + index * 0.1;
          const end = start + 0.2;
          // Create transforms inside loop (React allows this if order is stable)
          const cardY = useTransform(smoothProgress, [start, end], [100, 0]);
          const cardOpacity = useTransform(smoothProgress, [start, end], [0, 1]);
          const cardScale = useTransform(smoothProgress, [start, end], [0.9, 1]);
          return <motion.div key={index} style={{
            y: cardY,
            opacity: cardOpacity,
            scale: cardScale
          }} className="bg-white p-8 md:p-10 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] transition-shadow duration-300 group" data-id="element-62">
                <div className="w-12 h-12 bg-ivory rounded-full flex items-center justify-center mb-6 text-gold group-hover:bg-gold group-hover:text-white transition-colors duration-300" data-id="element-63">
                  <benefit.icon size={24} strokeWidth={1.5} data-id="element-64" />
                </div>
                <h3 className="text-xl font-serif text-softBlack mb-3" data-id="element-65">
                  {benefit.title}
                </h3>
                <p className="text-warmGray font-light leading-relaxed" data-id="element-66">
                  {benefit.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}